import { Link as RouterLink } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
import { Grid, Link, Divider, Container, Typography, Stack,  Button } from '@mui/material';
// routes
import Iconify from '../../components/Iconify';
import { PATH_PAGE } from '../../routes/paths';
// components
import Logo from '../../components/Logo';
import SocialsButton from '../../components/SocialsButton';
import useToggle from '../../hooks/useToggle';
import NewsLetterModal from '../../sections/newsletters/NewsLetterModal';

// ----------------------------------------------------------------------

const LINKS = [
  {
    headline: 'Lien Utiles',
    children: [
      { name: 'Actualité', href: PATH_PAGE.accueil.actualites },
      { name: 'Questions fréquentes', href: PATH_PAGE.accueil.foire_aux_question },
      { name: 'Contacts', href: PATH_PAGE.contact },
    ],
  },
];

const RootStyle = styled('div')(() => ({
  position: 'relative',
  backgroundColor: '#414141',
}));

// ----------------------------------------------------------------------

export default function MainFooter() {
  const {toggle, onOpen, onClose} = useToggle()
  const currentYear = new Date().getFullYear();

  return (
    <RootStyle>
      <Divider />
      <Container sx={{ pt: 5 }}>
        <Grid
          container
          justifyContent={{ xs: 'center', md: 'space-between' }}
          sx={{ textAlign: { xs: 'center', md: 'left' } }}
        >
          <Grid item xs={12} sx={{ mb: 3 }}>
            <Logo light sx={{ width: 150, height: 90, mx: { xs: 'auto', md: 'inherit' } }} />
          </Grid>

          <Grid item xs={8} md={4}>
            <Typography color="common.white" variant="body2" sx={{ pr: { md: 5 } }}>
              Agence de Promotion des Investissements et de la Zone Franche (API-ZF)
            </Typography>

            <Stack
              width={1}
              alignItems={{ xs: 'center', md: 'start' }}
              justifyContent={{ xs: 'center', md: 'flex-start' }}
              sx={{ mb: { xs: 2, md: 0 } }}
            >
              <Stack direction="row" alignItems="center" spacing={1}>
                <Typography color="common.white" variant="body2">
                  info@apizf.org
                </Typography>
              </Stack>

              <Stack direction="row" alignItems="center" spacing={1}>
                <Typography color="common.white" variant="body2">
                 Rue 2564, Avenue de la Chance BP: 3250, Lomé-Togo
                </Typography>
              </Stack>

              <Stack alignItems="center" spacing={1} mt={{ xs: 1, md: 2 }} color="common.white">
                {HORAIRES.map((ho, index) => (
                  <Stack direction="row" key={ho.day + index} width={1} spacing={1}>
                    <Stack width={30}>
                      <Typography variant="body2">{ho.day}</Typography>
                    </Stack>
                    <Stack>
                      <Typography variant="body2">{ho.hours} </Typography>
                    </Stack>
                  </Stack>
                ))}
              </Stack>

              <Stack direction="row" alignItems="center" spacing={1} mt={{ xs: 1, md: 2 }}>
                <Iconify icon="eva:smartphone-outline" sx={{ color: '#cb011c' }} />
                <Typography color="common.white" fontWeight="bold">
                  +228 22 53 53 53 / +228 90 28 33 32
                </Typography>
              </Stack>
            </Stack>
          </Grid>

          <Grid item xs={12} md={7}>
            <Stack spacing={5} direction={{ xs: 'column', md: 'row' }} justifyContent="space-between">
              {LINKS.map((list) => (
                <Stack key={list.headline} spacing={2}>
                  <Typography color="common.white" component="p" variant="overline">
                    {list.headline}
                  </Typography>
                  {list.children.map((link) => (
                    <Link
                      to={link.href}
                      key={link.name}
                      color="common.white"
                      variant="body2"
                      component={RouterLink}
                      sx={{ display: 'block' }}
                    >
                      {link.name}
                    </Link>
                  ))}
                  <Button color="primary" variant="contained" onClick={onOpen} sx={{ alignSelf: { xs: 'center', md: 'flex-start' } }}>
                    NEWSLETTER
                  </Button>
                </Stack>
              ))}
              <Stack spacing={2}>
                <SocialsButton initialColor simple={false} direction="column" />
              </Stack>
            </Stack>
          </Grid>
        </Grid>

        <Typography
          component="p"
          variant="body2"
          color="common.white"
          sx={{
            mt: 10,
            pb: 5,
            fontSize: 13,
            textAlign: { xs: 'center', md: 'center' },
          }}
        >
          © {currentYear} API-ZF. Tous droits réservés. Conception : Okydook.
        </Typography>
      </Container>

      {toggle && <NewsLetterModal open={Boolean(toggle)} onClose={onClose} />}

    </RootStyle>
  );
}

const HORAIRES = [
  { day: 'Lun', hours: '07:00 - 12:00 / 14:30 - 17:30' },
  { day: 'Mar', hours: '07:00 - 12:00 / 14:30 - 17:30' },
  { day: 'Mer', hours: '07:00 - 12:00 / 14:30 - 17:30' },
  { day: 'Jeu', hours: '07:00 - 12:00 / 14:30 - 17:30' },
  { day: 'Ven', hours: '06:30 - 14:00' },
];
